import { createFileRoute } from "@tanstack/react-router";
import { AdminCrawlerConfigurationPage } from "@/components/admin/pages/AdminCrawlerConfigurationPage";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities/configuration")({
  component: AdminCrawlerConfigurationPage,
});
